// eslint-disable-next-line no-unused-vars
import { urlMainAPI, defaultSuccess, showError } from "@/global";
import { mapState } from "vuex";
import * as moment from "moment";
import axios from "axios";
import { FiltersMixin } from "../mixins/filtersMixin";

export var OccurrenceMixin = {
  computed: mapState(["user"]),

  mixins: [ FiltersMixin ],

  provide() {
    return {
      getIndicatorSelected: this.getIndicator,
    };
  },

  data() {
    return {
      filteredIndicators: [],
      productionsUnitList: [],
      responsibleList: [],
      productionDate: '',
      productionUnit: '',
      system: '',
      deadline: 1,
      progress: 1,
      actions: [],
      cleanActions: null,
      canSave: false,
      occurrenceDescription: '',
      occurrenceObservation: '',
      workOrderOccurrence: '',
      enableWorkOrder: false,
      indicatorId: -9999,
      responsibleKey: null,
      responsible: null,
      responsibleId: -1,
      workshiftId: 4,
      processId: null,
      processName: null,
      equipmentId: null,
      equipmentName: null,
      productId: null,
      productName: null,
      optionsDatePicker: {
        locale: moment.locale("pt-br"),
        format: "DD/MM/YYYY",
        extraFormats: ["DD/MM/YYYY HH:mm:ss", "YYYY/MM/DD HH:mm:ss", "x"],
        dayViewHeaderFormat: "MMMM/YYYY",
        allowInputToggle: true,
        useCurrent: false,
        showTodayButton: true,
        showClear: true,
        showClose: true,
        sideBySide: false,
        inline: false,
        keepOpen: false,
        tooltips: {
          today: "Hoje",
          clear: "Limpar",
          close: "Fechar",
          selectMonth: "Selecionar mês",
          prevMonth: "Mês anterior",
          nextMonth: "Próximo mês",
          selectYear: "Selecionar ano",
          prevYear: "Ano anterior",
          nextYear: "Próximo ano",
          selectDecade: "Selecionar década",
          prevDecade: "Década anterior",
          nextDecade: "Próxima década",
          prevCentury: "Século anterior",
          nextCentury: "Próximo século",
        },
      },
      node: {},
      reasonContent: "",
    }
  },

  methods: {
    loadProductionsUnitList() {
      const url = `${urlMainAPI}/getproductionunitlist`;
      axios.get(url).then((res) => {
        this.productionsUnitList = res.data.productionUnitList;
        if (this.user.UnitId != 1) this.productionsUnitList = this.productionsUnitList.filter(pu => pu.id == parseInt(this.user.UnitId))
        if(this.productionsUnitList.length == 1)
          this.productionUnit = this.productionsUnitList[0];
      }).catch(console.log);
    },

    setProductionUnit(e) {
      let unitInitials = e.target.value;
      let productionUnit = this.productionsUnitList.find(
        (unit) => unit.initials == unitInitials
      );
      this.productionUnit = productionUnit;
    },

    isGreaterThanNinety(e) {
      let inputValue = e.target.value;
      if (inputValue < 1) {
        showError(this.$t('o-valor-deve-ser-maior-que-0'));
        this.progress = 1;
      }
    },

    loadResponsibleList() {
      const unitId = this.productionUnit.id || 1;

      const url = `${urlMainAPI}/getresponsiblesbyunit/${unitId}`;
      axios.get(url).then((res) => {
        if (typeof res.data == "string") this.responsibleList = [];
        else this.responsibleList = res.data.responsibleList;

      });
    },

    setResponsible() {
      let key = this.formatResponsibleKey()
      this.responsible = this.responsibleList.find(
        (r) => r.id == key.id && r.unitId == key.unitId && r.system == key.system
      );
      this.responsibleId = parseInt(key.id);
      this.responsibleUnitId = parseInt(key.unitId);
    },

    formatResponsibleKey() {
      let key = this.responsibleKey.split("-");
      return { id: key[0], unitId: key[1], system: key[2] }
    },

    updateActionsList(actionslist){
      this.actions = actionslist
      this.calcDeadline()
      this.updateReasonContent()
    },

    updateReasonContent() {
      let actionList = new Array();
      this.actions.forEach((a) => {
          actionList.push({
          action: a.action,
          date: this.MaskDate(a.date),
          name: a.name,
          responsableId: a.responsible.id,
          responsableUnitId: a.responsible.unitId,
          responsableSystem: a.responsible.system,
          reasonId: this.node.node.id,
          createdBy: this.user.Id,
          actionId: Math.random()
        });
      });

      let reasonSelected = {
        title: this.occurrenceDescription,
        id: this.node.node.id,
        reasonTreeId: this.node.node.id,
        createdBy: this.user.Id,
        hasOtherDesc: false,
        reasonOtherDescription: '',
        actions: actionList,
      }
      
      let reasonList = []
      
      reasonList.push(reasonSelected);
      
      this.reasonContent = JSON.stringify({ reasons: reasonList })
    },

    calcDeadline(){
      this.deadline = -120
      this.actions.forEach(x => {
        let maxDay = this.DiffInDays(this.MaskDate(new Date()), x.date)
        this.deadline = maxDay > this.deadline ? maxDay : this.deadline
      })
      if(this.deadline == -120)
        this.deadline = 0
    },

    applyReaseon(value) {
      this.node = value
      this.occurrenceDescription = value.path;
      this.confirmDuplicateOccurrence();
    },

    async confirmDuplicateOccurrence(){
      let occurrence = {
        productionUnitId: this.productionUnit.id,
        system: this.system,
        description: this.occurrenceDescription,
        observation: this.occurrenceObservation,
        indicatorId: this.getIndicatorId()
      }

      const url = `${urlMainAPI}/checkduplicateoccurrence`;
      await axios.post(url, occurrence).then((res) => {
        if(res.data == true || res.data == "true"){
          this.$bvModal.show('confirmDuplicateOccurrence')
        }
      }).catch((er) => {
        showError(er.data);
      });
    },
    
    getIndicatorId(){
      let indicatorId2 = this.indicatorId;
      if ((indicatorId2 || indicatorId2 == 0) && typeof indicatorId2 == "number") {
        indicatorId2 = [indicatorId2];
      }
      return indicatorId2;
    },

    getIndicator() {
      return {
        id: this.indicatorId,
        productionUnitId: this.productionUnit.id,
        system: this.system,
      };
    },

    async saveOccurrence() {
      let result = false;   
      // if (this.responsibleId == null || this.responsibleId == -1 || isNaN(this.responsibleId)) {
      //   showError(this.$t('selecione-um-responsavel-para-salvar-a-ocorrencia'));
      //   return;
      // } else 
      
      if (this.indicatorId == null) {
        showError(this.$t('selecione-um-indicador-para-salvar-a-ocorrencia'));
        return;
      } else if (!this.occurrenceDescription || this.occurrenceDescription.length == 0) {
        showError(this.$t('informe-um-motivo-para-a-ocorrencia'));
        return;
      } else if (!this.actions || this.actions.length == 0) {
        showError(this.$t('adicione-ao-menos-uma-acao-para-a-ocorrencia'));
        return;
      } else if (this.user.onlineType == 'PGDI' && !this.processId) {
        showError(this.$t('selecione-um-processo-1'));
        return;
      } else if (this.enableWorkOrder && !this.workOrderOccurrence) {
        showError(this.$t('campo-ordem-de-servico-e-obrigatorio'));
        return;
      } else {
        this.canSave = true
        this.buildJsonOccurrenceToSave()

        console.log('this.occurrence', this.occurrence)

        const url = `${urlMainAPI}/saveoccurrence`;
        await axios
          .post(url, this.occurrence)
          .then((res) => {
            defaultSuccess(res.data);
            this.cleanFields();
            result = true;
          })
          .catch((er) => {
            showError(er.data);
            result = false;
          });

        return result
      }
    },

    cleanFields() {
      this.responsible = null;
      this.occurrenceDescription = "";
      this.occurrenceObservation = "";
      this.deadline = 1;
      this.progress = 1;
      this.actions = [];
    },

    buildJsonOccurrenceToSave(){
      let indicatorId2 = this.getIndicatorId();
      let period = this.BuildPeriod()

      let actionList = new Array();
      this.actions.forEach((a) => {
        actionList.push({
          action: a.action,
          date: this.MaskDate(a.date),
          name: a.name,
          responsableId: a.responsible.id,
          responsableUnitId: a.responsible.unitId,
          responsableSystem: a.responsible.system,
        });
      });

      let indicator = this.filteredIndicators.find(i => i.id == indicatorId2);

      this.occurrence = { 
        ...this.occurrence,
        id: 0,
        indicatorId: indicatorId2,
        productionUnitId: this.productionUnit.id ? this.productionUnit.id : -9999,
        productionUnitName: this.productionUnit.name,
        system: this.system,
        description: this.occurrenceDescription,
        observation: this.occurrenceObservation,
        responsibleId: this.responsibleId,
        responsibleUnitId: this.responsibleUnitId,
        phaseId: 1,
        deadline: period.deadline,
        profileId: 3,
        statusId: 1,
        workshift: this.workshiftId,
        baseDate: period.baseDate,
        documentContent: null,
        creationDate: moment().format("YYYY-MM-DD hh:mm:ss"),
        content: JSON.stringify({ 
          target: indicator ? indicator.target : "0,00",
          value: indicator ? indicator.value : "0,00",
          consecutiveObservations: this.progress,
          actionsList: actionList,
          processId: this.processId,
          processName: this.processName || "Não informado",
          equipmentId: this.equipmentId,
          equipmentName: this.equipmentName || "Não informado",
          productId: this.productId,
          productName: this.productName || "Não informado",
          workOrder: this.workOrderOccurrence
        }),
        reasonContent: this.reasonContent
      };
    },

    BuildPeriod(){
      let baseDate = this.formatBaseDate(this.productionDate);
      let dateNow = this.formatBaseDate(moment());

      var diff = moment(dateNow,"YYYY-MM-DD").diff(moment(baseDate,"YYYY-MM-DD"));
      var dias = moment.duration(Math.abs(diff)).asDays();

      let deadline = moment(baseDate)
        .add(dias + parseInt(this.deadline) - 1, "day")
        .format()
        .substring(0, 10);

      if(this.user.role == "GDI")
        baseDate = baseDate + " 23:59:59";
      else
        baseDate = baseDate + " " + moment().format("hh:mm:ss");
      
      deadline = deadline + " 23:59:59";
      console.log('baseDate :>> ', baseDate);

      return { baseDate, deadline }
    },

    formatBaseDate(baseDate) {
      if (typeof baseDate == "object") {
        baseDate = baseDate.format().substring(0, 10);
      } else {
        baseDate = baseDate.split("/").reverse();
        baseDate = baseDate.join("-");
      }
      return baseDate;
    },

    async getCurrentWorkshift() {
      try {
        const url = `${urlMainAPI}/getworkshift`;
        const response = await axios.get(url);
        
        let workshifts = [];
        
        if (response.data) {
          if (typeof response.data === 'string') {
            try {
              workshifts = JSON.parse(response.data);
            } catch (parseError) {
              console.error('Erro ao fazer parse da resposta:', parseError);
              workshifts = response.data;
            }
          } else {
            workshifts = response.data;
          }
          
          if (!Array.isArray(workshifts)) {
            console.error('A resposta não é um array de turnos:', workshifts);
            this.setDefaultWorkshift();
            return;
          }
          
          const currentTime = moment().format("HH:mm:ss");
          
          for (const workshift of workshifts) {
            if (workshift.description === "Dia") continue;
            
            const startTime = workshift.startTime;
            const endTime = workshift.endTime;
            
            if (startTime > endTime) {
              if (currentTime >= startTime || currentTime < endTime) {
                this.workshiftId = workshift.id;
                return;
              }
            } else {
              if (currentTime >= startTime && currentTime < endTime) {
                this.workshiftId = workshift.id;
                return;
              }
            }
          }
          
          this.workshiftId = 4;
        } else {
          console.warn('Resposta vazia da API de turnos');
          this.setDefaultWorkshift();
        }
      } catch (error) {
        console.error('Erro ao obter turno atual:', error);
        this.setDefaultWorkshift();
      }
    },
    
    setDefaultWorkshift() {
      const hour = moment().hour();
      if (hour >= 22 || hour < 6) this.workshiftId = 1;
      else if (hour >= 6 && hour < 14) this.workshiftId = 2;
      else if (hour >= 14 && hour < 22) this.workshiftId = 3;
      else this.workshiftId = 4;
    },
  },

  async created() {
    this.system = this.$store.state.system == "GDI" ? "G" : "P";
    this.productionDate = moment().subtract(1, "day");
    await this.getCurrentWorkshift(); // Obtém o turno atual da API
    this.loadProductionsUnitList();
  },
};
